import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Icons } from '../../../shared/helpers/icons';
import { CommonModule } from '@angular/common';
import { LucideAngularModule } from 'lucide-angular';
import { UserDataService } from '../../../shared/services/auth/userData.service';
import { EStatus, EYesNo } from '../../../shared/models/types.enum';
import { SpinnerComponent } from '../spinner/spinner.component';
import { AssessCaseService } from '../../../shared/services/assessCase.service';
import { IAssessCase } from '../../../shared/models/assessCase';
import { DownloadFileService } from '../../../shared/services/downloadFile.service';
import { RoarAssignmentFormService } from '../../../shared/services/roarAssignmentForm.service';
import { PopupMessageComponent } from '../popup-message/popup-message.component';

@Component({
  selector: 'download-docs',
  standalone: true,
  imports: [
    CommonModule,
    LucideAngularModule,
    SpinnerComponent,
    PopupMessageComponent
  ],
  templateUrl: './download-docs.component.html',
  styleUrl: './download-docs.component.css'
})
export class DownloadDocsComponent implements OnInit {

  @Input() case: any | null = null;
  @Output() onClose = new EventEmitter<void>();
  @Output() onSave = new EventEmitter<any>();

  icons = Icons;
  yesNo = EYesNo;
  formStatus = EStatus;
  currentBuildingId: string | null = null;
  currentUserId: number | null = null;
  roarAssignmentForms: any[] | null = null;
  messageModal: string | null = null;
  popupMessage: string | null = null;

  loading: boolean = false;
  documentsList = [
    {
      stage: 'Evaluations',
      docs: [ { label: 'Behavioral Threat Assessment Screening', name: 'behavioral_assessment_screen' } ]
    },
    {
      stage: 'Assessments',
      docs: [ 
        { label: 'Full Team Threat Assessment', name: 'full_team_threat_assessment' },
        { label: 'Teacher Staff Interview', name: 'teacher_staff_interview' }, 
        { label: 'Witness Interview', name: 'witness_interview' },
        { label: 'Student of Concern Interview', name: 'student_of_concern_interview' }, 
        { label: 'Parent Interview', name: 'parent_interview' }
      ]
    },
    {
      stage: 'Plans',
      docs: [ 
        { label: 'RMS Plan Checklist', name: 'rms_plan_checklist' },
        { label: 'RMS Plan Review Schedule', name: 'rms_plan_review_schedule' }, 
        { label: 'RMS Plan Summary', name: 'rms_plan_summary' }
      ]
    },
    {
      stage: 'Interventions',
      docs: [ { label: 'Threat Assessment Summary', name: 'threat_assessment_summary' } ]
    },
    {
      stage: 'Monitoring',
      docs: [ 
        { label: 'ROAR Assignment Form', name: 'roar_assignment_form' }, 
        {label: 'RMS Record of Review', name: 'rms_record_review' },
        { label: 'Case Closing Summary', name: 'case_closing_summary' }
      ]
    }
  ];

  constructor(
    private downloadFileService: DownloadFileService,
    private userDataService: UserDataService,
    private roarAssignmentFormService: RoarAssignmentFormService
  ) { }

  ngOnInit(): void {
    this.currentBuildingId = this.userDataService.getBuildingId();
    this.currentUserId = this.userDataService.getCurrentUser()?.user_id || null;
    this.loadCompletedRoarAssignmentFormByCaseId(this.case.case_id);
  }

  loadCompletedRoarAssignmentFormByCaseId(caseId: string): void {
    if (this.case.case_id) {
      this.loading = true;
      this.roarAssignmentFormService.getCompletedRoarAssignmentFormByCaseId(caseId).subscribe({
        next: (response) => {
          this.roarAssignmentForms = response;
          this.loading = false;
        },
        error: (error) => {
          console.error('Error loading completed ROAR Assignment Form:', error.message);
          this.loading = false;
        }
      });
    }
  }

  downloadFile(form_name: string, caseId: string): void {
    this.loading = true;
    this.downloadFileService.downloadFile(form_name, caseId).subscribe({
      next: (response) => {
        const blob = new Blob([response], { type: 'application/pdf' });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `${form_name}_${caseId}.pdf`;
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
        a.remove();
        this.loading = false;
      },
      error: (error) => {
        console.error('Error downloading file:', error.message);
        this.loading = false;
        this.messageModal = 'unsuccess';
        this.popupMessage = error?.error?.detail || error.message;
      }
    });
  }

  isAtLeastOneRoarAssignmentForm(): boolean {
    if (this.roarAssignmentForms && this.roarAssignmentForms.length > 0) {
      return true;
    }
    return false;
  }

  onCloseClick(): void {
    this.onClose.emit();
  }

  resetMessageModal(): void {
    this.messageModal = null;
    this.popupMessage = null;
  }

}
